import { ChangeEventHandler, FC } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'

interface ITextareaFieldProps {
  placeholderTranslationKey: string
  value?: string
  onChange?: ChangeEventHandler<HTMLTextAreaElement>
}

export const TextareaField: FC<ITextareaFieldProps> = ({
  placeholderTranslationKey,
  value,
  onChange,
}) => {
  const translationMode = useSelector(selectTranslationMode)
  const t = useSafetyTranslation()

  if (translationMode === 'edit') {
    return <Translation text={placeholderTranslationKey} />
  }

  return (
    <textarea
      rows={4}
      placeholder={t(placeholderTranslationKey)}
      value={value}
      onChange={onChange}
    />
  )
}
